window.WOODEvents = (() => {

  function init() {

    const els = window.els;

    if (!els) return;
/* =========================
   BUILDER STEP NAVIGATION
========================= */

const steps =
  document.querySelectorAll(".builder-step");

let currentStep = 1;

function showStep(stepNumber) {

  steps.forEach(step => {

    step.classList.remove("active-step");

    if (
      parseInt(step.dataset.step) === stepNumber
    ) {
      step.classList.add("active-step");
    }
  });

  currentStep = stepNumber;

  updateProgressBar();
}

function updateProgressBar() {

  const progressBar =
    document.querySelector(".progress-bar");

  if (!progressBar) return;

  const percent =
    ((currentStep - 1) / (steps.length - 1)) * 100;

  progressBar.style.width = percent + "%";
}

/* NEXT BUTTONS */

document.querySelectorAll(".next-step")
.forEach(btn => {

  btn.addEventListener("click", function () {

    if (currentStep < steps.length) {

      showStep(currentStep + 1);
    }
  });
});

/* BACK BUTTONS */

document.querySelectorAll(".prev-step")
.forEach(btn => {

  btn.addEventListener("click", function () {

    if (currentStep > 1) {

      showStep(currentStep - 1);
    }
  });
});

/* INITIALIZE */

showStep(1);
/* =========================
   FONT CARDS
========================= */

document
  .querySelectorAll(".font-card")
  .forEach(card => {

    card.addEventListener("click", function () {

      document
        .querySelectorAll(".font-card")
        .forEach(c =>
          c.classList.remove("active")
        );

      this.classList.add("active");

      const font =
        this.dataset.font;

      if (window.activeTextLayer) {

        window.activeTextLayer.style.fontFamily =
          font;

      } else if (els.previewText) {

        els.previewText.style.fontFamily =
          font;

      }

      if (window.updateTextStyle) {
        window.updateTextStyle();
      }

      window.WOODStorage?.save();

    });

  });
/* =========================
   COLOR SWATCHES
========================= */

document
  .querySelectorAll(".color-swatch")
  .forEach(swatch => {

    swatch.addEventListener("click", function () {

      document
        .querySelectorAll(".color-swatch")
        .forEach(s =>
          s.classList.remove("active")
        );

      this.classList.add("active");

      window.WOODPricing?.updatePrice();

      window.WOODStorage?.save();

    });

  });
  /* =========================
   TEXT SIZE
========================= */

if (els.textSizeSlider) {

  els.textSizeSlider.addEventListener(
    "input",
    function () {

      const active =
        window.activeTextLayer;

      if (active) {

        active.style.fontSize =
          this.value + "px";

      } else if (els.previewText) {

        els.previewText.style.fontSize =
          this.value + "px";

      }

      window.WOODPricing?.updatePrice();

      window.WOODStorage?.save();

    }
  );

}
/* =========================
   TEXT COLOR
========================= */

if (els.textColorPicker) {

  els.textColorPicker.addEventListener(
    "input",
    function () {

      const active =
        window.activeTextLayer;

      const target =
        active || els.previewText;

      if (!target) return;

      target.style.color =
        this.value;

      window.WOODStorage?.save();

    }
  );

}

    /* =========================
       SHAPE CARDS
    ========================= */

    document
      .querySelectorAll(".shape-card")
      .forEach(card => {

        card.addEventListener("click", () => {

          document
            .querySelectorAll(".shape-card")
            .forEach(c =>
              c.classList.remove("active")
            );

          card.classList.add("active");

          const shape =
            card.dataset.shape;

          const selector =
            document.getElementById("shapeSelector");

          selector.value = shape;

          selector.dispatchEvent(
            new Event("change")
          );

        });

      });

    /* =========================
       SAVE BUTTON
    ========================= */

    if (els.saveBtn) {

      els.saveBtn.addEventListener(
        "click",
        window.WOODStorage.save
      );

    }

    /* =========================
       LOAD BUTTON
    ========================= */

    if (els.loadBtn) {

      els.loadBtn.addEventListener(
        "click",
        window.WOODStorage.load
      );

    }

    /* =========================
       UNDO BUTTON
    ========================= */

    if (els.undoBtn) {

      els.undoBtn.addEventListener(
        "click",
        window.undoDesign
      );

    }

    /* =========================
       TEXT INPUT
    ========================= */

    if (els.textInput) {

      els.textInput.addEventListener(
        "input",
        function () {

          window.WOODPricing.updatePrice();

          window.WOODStorage.save();

        }
      );

    }

    /* =========================
       SELECT CHANGES
    ========================= */

    [
  els.sizeSelector,
  els.woodType,
  els.layerSelector,
  els.stainSelector,
  els.textStyle,
  els.rushOrder,
  els.detailToggle
].forEach(el => {

      if (!el) return;

      el.addEventListener(
        "change",
        function () {

          window.WOODPricing.updatePrice();

          window.WOODStorage.save();

        }
      );

    });

    /* =========================
       TEXT SIZE
    ========================= */

    if (els.textSizeSlider) {

      els.textSizeSlider.addEventListener(
        "input",
        function () {

          window.WOODPricing.updatePrice();

        }
      );

    }
 

    /* =========================
       ADD TEXT LAYER
    ========================= */

    if (els.addTextLayerBtn) {

      els.addTextLayerBtn.addEventListener(
        "click",
        () => {

          const newText =
            document.createElement("div");

          newText.className = "draggable-text";
          newText.dataset.extra = "true";

          newText.contentEditable = false;

          newText.innerText =
            "Your Text";

          newText.style.position =
            "absolute";

          newText.style.top = "50%";

          newText.style.left = "50%";

          newText.style.transform =
            "translate(-50%, -50%)";

          newText.style.color =
            els.textColorPicker?.value || "#000";

          newText.style.fontSize =
            (els.textSizeSlider?.value || 40) + "px";

          newText.style.cursor =
            "move";

          newText.style.zIndex = "20";

          els.addonLayer.appendChild(newText);

          window.WOOD_STATE.activeTextLayer =
            newText;

        }
      );

    }

    /* =========================
       TEXT COLOR
    ========================= */

    if (els.textColorPicker) {

      els.textColorPicker.addEventListener(
        "input",
        () => {

          const active =
            window.WOOD_STATE.activeTextLayer;

          if (active) {

            active.style.color =
              els.textColorPicker.value;

          }

        }
      );

    }

    /* =========================
       TEXT SIZE
    ========================= */

    if (els.textSizeSlider) {

      els.textSizeSlider.addEventListener(
        "input",
        () => {

          const active =
            window.WOOD_STATE.activeTextLayer;

          if (active) {

            active.style.fontSize =
              els.textSizeSlider.value + "px";

          }

        }
      );

    }
  }

  return {
    init
  };

})();